// extracted by mini-css-extract-plugin
module.exports = {"intro__tags":"styles_intro__tags__DhFRF","rotate":"styles_rotate__83bei","rotate-reverse":"styles_rotate-reverse__OjGS7"};